var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#telegram_svg__a)",
    fillRule: "evenodd",
    d: "M21.84 6.056a1.5 1.5 0 0 0-2.062-1.626l-17.1 7.2c-1.193.502-1.254 2.226 0 2.746a57 57 0 0 0 3.773 1.418c1.169.386 2.442.743 3.463.844.28.334.63.656.988.95.547.45 1.206.913 1.886 1.357 1.361.89 2.872 1.741 3.89 2.295 1.217.66 2.674-.1 2.893-1.427zM4.595 12.993 19.72 6.624l-2.118 12.84c-.998-.543-2.438-1.356-3.72-2.194a20 20 0 0 1-1.709-1.229 8 8 0 0 1-.426-.374l3.962-3.96a1 1 0 0 0-1.415-1.415L9.955 14.63c-.733-.094-1.756-.366-2.878-.736a49 49 0 0 1-2.482-.902",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram_svg__a",
    x1: 20.077,
    x2: -18.279,
    y1: 4.784,
    y2: 21.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgTelegram;